<script lang="ts">
  import type { Snippet } from 'svelte';

  // Placeholder for sections with no data yet — donations list before the
  // user donates, stats list before they play. Optional `action` snippet
  // for a CTA button (e.g. "Play your first round").

  interface Props {
    title: string;
    body?: string;
    action?: Snippet;
  }

  let { title, body, action }: Props = $props();
</script>

<div class="ui-empty-state">
  <h3 class="ui-empty-state__title">{title}</h3>
  {#if body}<p class="ui-empty-state__body">{body}</p>{/if}
  {#if action}<div class="ui-empty-state__action">{@render action()}</div>{/if}
</div>
